import React from 'react';
import { useMenuIconAnimation } from './useMenuIconAnimation';
import './DocumentsAnimatedIcon.css';

const ACTIVE_COLOR = '#3262FF';
const INACTIVE_COLOR = '#282932';

const CLIP_PATH = `
  M16.5 14.5
  V17.5
  C16.5 18.7 17.2 19.5 18.2 19.5
  C19.2 19.5 19.9 18.7 19.9 17.5
  V14.9
  C19.9 14.0 19.3 13.4 18.4 13.4
  C17.5 13.4 16.9 14.0 16.9 14.9
  V17.0
  C16.9 17.7 17.3 18.1 17.9 18.1
  C18.5 18.1 18.9 17.7 18.9 17.0
  V15.5
`;

const DOC_BODY_PATH = 'M 5 3 H 13.5 L 17.5 7 V 19 A 2 2 0 0 1 15.5 21 H 5 A 2 2 0 0 1 3 19 V 5 A 2 2 0 0 1 5 3 Z';

function DocumentsAnimatedIcon({ color, isActive = false, size = 24 }) {
  const strokeColor = color || (isActive ? ACTIVE_COLOR : INACTIVE_COLOR);
  const { playing, handleClick } = useMenuIconAnimation(isActive, 1750);

  return (
    <span
      className={[
        'documents-animated-icon',
        playing ? 'documents-animated-icon--playing' : '',
        isActive && !playing ? 'documents-animated-icon--active' : '',
      ].filter(Boolean).join(' ')}
      style={{ '--doc-icon-stroke': strokeColor, width: size, height: size }}
      onClick={handleClick}
      role="presentation"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          className="doc-icon-stroke doc-icon-body"
          d={DOC_BODY_PATH}
        />
        <path
          className="doc-icon-stroke doc-icon-fold"
          d="M13.5 3 V7 H17.5"
        />
        <path className="doc-icon-line doc-icon-line1" d="M5.5 11 H14.5" />
        <path className="doc-icon-line doc-icon-line2" d="M5.5 14.5 H14.5" />
        <path className="doc-icon-line doc-icon-line3" d="M5.5 18 H11.5" />
        <path className="doc-icon-clip" d={CLIP_PATH} />
      </svg>
    </span>
  );
}

export default DocumentsAnimatedIcon;
